<script setup lang="ts">

</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
        <path d="M62.5626 53.9747H9.4617C8.13418 53.9747 7.04802 52.7379 7.04802 51.2263V12.7484C7.04802 11.2368 8.13418 10 9.4617 10H62.5626C63.8901 10 64.9763 11.2368 64.9763 12.7484V51.2263C64.9763 52.7379 63.8901 53.9747 62.5626 53.9747ZM11.8754 48.4779H60.1489V15.4968H11.8754V48.4779Z" fill="currentColor"/>
        <path d="M69.5863 62H2.41368C1.08615 62 0 60.7632 0 59.2516C0 57.74 1.08615 56.5032 2.41368 56.5032H69.5863C70.9138 56.5032 72 57.74 72 59.2516C72 60.7632 70.9138 62 69.5863 62Z" fill="currentColor"/>
    </svg>
</template>

<style scoped>

</style>